import React, {Component} from 'react';
import IgniteDataTable from '../../../common/datatable';
import ConfirmPopup from '../../../common/confirm-popup';
import {dateTimeFormatUK, dateFormatUK} from '../../../../utils/commonFunctions';
import store, {history} from '../../../../store';
import { deactivatePpcUser } from '../../../../actions/ppc';

class PpcUsersList extends Component {
  state = {
    deactivate: {
      show: false
    }
  };

  render() {
    const columns = [
      {
        prop: 'user-id',
        title: 'User ID',
        width: '75',
        onClick(data) {
          history.push(`/admin/users/${data}/details`);
        }
      },
      {
        prop: 'first-name',
        title: 'First Name'
      },
      {
        prop: 'last-name',
        title: 'Last Name'
      },
      {
        prop: 'email',
        title: 'Email'
      },
      {
        prop: 'mobile',
        title: 'Mobile',
        width: '120'
      },
      {
        prop: 'created-at',
        title: 'Opt in date',
        format(data) {
          return dateTimeFormatUK(data);
        }
      },
      {
        prop: 'active',
        title: 'Active',
        width: '60',
        format(data) {
          return data ? 'Y' : 'N';
        }
      },
      {
        prop: 'deactivation-date',
        title: 'Deactivation date',
        format(data) {
          return data ? dateFormatUK(data) : '';
        }
      },
      {
        prop: 'kyc-status',
        title: 'KYC status',
        width: '100'
      },
      {
        prop: 'account-number',
        title: 'PPC acc#',
        width: '100'
      },
    ];

    const actions = [
      {
        label: 'View',
        permissions: {
          action: 'read',
          subjectClass: 'PpcUser',
          mode: 'disable'
        },
        callback: (row) => {
          history.push(`/admin/ppc/management/${row.id}`);
        }
      },
      {
        label: 'Deactivate',
        permissions: {
          action: 'manage',
          subjectClass: 'PpcUser',
          mode: 'disable'
        },
        disabled: row => !row.attributes.active,
        callback: (row) => {
          this.setState({
            deactivate: {
              show: true,
              id: row.id
            }
          });
        }
      },
    ];

    const handleDeactivation = (result) => {
      const { id } = this.state.deactivate;
      this.setState({deactivate: {show: false}});
      if (result) {
        store.dispatch(deactivatePpcUser(id));
      }
    };

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={this.props.users}
          dataSize={this.props.pagination.number * this.props.pagination.size}
          hideId={false}
          pagination={{
            onPageChange: this.props.onPageChange,
            page: this.props.currentPage,
            sizePerPage: 20,
          }}
          remote
          inlineActions={false}
        />
        {
          this.state.deactivate.show && (
            <ConfirmPopup
              header="DEACTIVATE PREPAID CARD USER?"
              onClose={handleDeactivation}
            >
              <p>
                Are you sure you want to deactivate this prepaid card user? If you
                continue, the user previously linked to this record will be required to
                opt in to the prepaid card again
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

export default PpcUsersList;



// WEBPACK FOOTER //
// ./src/components/admin/ppc/management/ppc-list.jsx